import React from 'react';
import PaymentsTab from './components/payments-tab';
import './style.scss';

const PaymentList = () => {
	return <PaymentsTab />;
};

export default PaymentList;
